<template>
  <div>
    <div class="bodyWrap">
      <header>
        <div class="headTop">
          <div class="topBox">
            <div class="headLeft fl">
              <span>时间：2021年3月31日</span>
              <span>星期三</span>
            </div>
            <div class="headRig fr">
              <router-link to="/login" tag="span">登录</router-link>
              <router-link to="/register" tag="span">注册</router-link>
            </div>
          </div>
        </div>
        <div class="headBottom">
          <div class="bottomBox">
            <div class="botLeft fl">
              <img src="../../assets/img/show/logo.png" alt="">
            </div>
            <div class="botdRig fr">
              <ul class="fl headUl">
                <li>资源管理</li>
                <li>统计分析</li>
                <li>返回信息网</li>
              </ul>
              <div class="fr headSearch">
                <el-input v-model="input" placeholder="发现数据从这里开始"></el-input>
                <span>
                              <img src="../../assets/img/show/search.png" alt="">
                          </span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="banner">
        <img src="../../assets/img/show/banner.png" alt="">
      </div>
      <div class="main">
        <div class="tabZujian">
          <div class="title">
            <p>当前位置：首页 > 搜索结果页 > 云研78-768</p>
          </div>
          <div class="resourceCon">
            <div class="conLeft">
              <div class="leftBox1">
                <h1>云研78-768 <img src="../../assets/img/show/xing.png" alt=""></h1>
                <h2 class="titleSet">种质基本信息</h2>
                <div class="infoBox">
                  <ul>
                    <li>
                      <p>种质编号：<span>RRICCATASOXJWD00764</span></p>
                      <p>种质名称：<span>云研78-768 </span></p>
                      <p>种质外文名称：<span>Yun Yan 78-768</span></p>
                    </li>
                    <li>
                      <p>科名：<span>大科名</span></p>
                      <p>属名和亚属名：<span>橡胶树属</span></p>
                      <p>种名：<span>巴西橡胶</span></p>
                    </li>
                    <li>
                      <p>种质资源类型：<span>选育品种</span></p>
                      <p>主要特性：<span>高产;抗逆</span></p>
                      <p>主要用途：<span></span></p>
                    </li>
                    <li><p class="wid100">资源描述：<span>资源描述资源描述资源描述资源描述资源描述资源描述</span></p></li>
                    <li><p class="wid100">资源图片：<span></span></p></li>
                  </ul>
                </div>
              </div>
              <div class="leftBox2">
                <h2 class="titleSet">种质资源收集信息</h2>
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                  <el-table-column
                      prop="date"
                      label="收集号"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="name"
                      label="采集号"
                      width="100"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="name"
                      label="引种号"
                      width="100">
                  </el-table-column>
                  <el-table-column
                      prop="sjdw"
                      label="收集单位">
                  </el-table-column>
                  <el-table-column
                      prop="sjsj"
                      label="收集时间">
                  </el-table-column>
                  <el-table-column
                      fixed="right"
                      label="详细信息"
                      width="100"
                  >
                    <template slot-scope="scope">
                      <el-button @click="handleClick(scope.row)" type="text" size="small">点击查看</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="leftBox3">
                <h2 class="titleSet">种质资源收集信息</h2>
                <el-table
                    :data="tableData2"
                    border
                    style="width: 100%">
                  <el-table-column
                      prop="bcdw"
                      label="保存单位">
                  </el-table-column>
                  <el-table-column
                      prop="address"
                      label="保存地点">
                  </el-table-column>
                  <el-table-column
                      prop="address2"
                      label="所属种质浦">
                  </el-table-column>
                  <el-table-column
                      prop="pbh"
                      label="浦编号"
                      width="100"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="kbh"
                      label="库编号"
                      width="100">
                  </el-table-column>
                  <el-table-column
                      fixed="right"
                      label="详细信息"
                      width="100"
                  >
                    <template slot-scope="scope">
                      <el-button @click="handleClick2(scope.row)" type="text" size="small">点击查看</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="conRig fr">
              <div class="rigBox1">
                <h2>相关内容</h2>
                <ul>
                  <li><img src="../../assets/img/show/btn1.png" alt="" @click="dialogFormVisible = true"></li>
                  <li><img src="../../assets/img/show/btn2.png" alt="" @click="dialogFormVisible2 = true"></li>
                  <li><img src="../../assets/img/show/btn3.png" alt="" @click="dialogFormVisible3 = true"></li>
                </ul>
              </div>
              <div class="rigBox2">
                <h2>热点资源</h2>
                <ul>
                  <li>云研95-9</li>
                  <li>云研95-8</li>
                  <li>云研95-7</li>
                  <li>云研95-6</li>
                  <li>云研95-5</li>
                  <li>云研95-4</li>
                  <li>云研95-3</li>
                  <li>云研95-2</li>
                  <li>云研95-10</li>
                  <li>云研95-1</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <p>主持单位:中国热带农业科学院热带作物品种资源研究所 | 版权所有©热带作物种质资源信息网</p>
      </footer>
    </div>
    <!--申请资源弹窗-->
    <div class="shenqin">
      <el-dialog title="申请资源" :visible.sync="dialogFormVisible" center>
        <el-form :model="form">
          <el-form-item label="单位/个人名称：" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off" placeholder="请输入单位或个人名称"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="地址：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="利用目的：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="利用材料：" :label-width="formLabelWidth">
            <el-select v-model="form.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提供数量：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入数量"></el-input>
          </el-form-item>
          <el-form-item label="提供种质形态：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入种质形态"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogFormVisible = false">提 交</el-button>
        </div>
      </el-dialog>
    </div>
    <!--异议提交弹窗-->
    <div class="shenqin">
      <el-dialog title="异议提交" :visible.sync="dialogFormVisible2" center>
        <el-form :model="form">
          <el-form-item label="单位/个人名称：" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off" placeholder="请输入单位或个人名称"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="地址：" :label-width="formLabelWidth">
            <el-input autocomplete="off" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="问题类型：" :label-width="formLabelWidth">
            <el-select v-model="form.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细内容：" :label-width="formLabelWidth">
            <el-input autocomplete="off" type="textarea" v-model="form.desc" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogFormVisible2 = false">提 交</el-button>
        </div>
      </el-dialog>
    </div>
    <!--区块链记录弹窗-->
    <div class="shenqin qkl">
      <el-dialog title="区块链记录" :visible.sync="dialogFormVisible3" center>
        <el-tabs v-model="activeName">
          <el-tab-pane label="归属变更" name="first" :key="'first'">
            <div class="bzt">
              <ul>
                <p class="lineLeft"></p>
                <li>
                  <dd><img src="../../assets/img/show/tcIco1.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span><a href="##">归属地变更</a></h1>
                    <p>
                      <span>变更内容：</span>这是一段文字这是一段文字这是一段文字这是一段
                      文字这是一段文字这是一段文字这是一段文字这是一段文字这
                      是一段文字这是一段文字这是一段文字这是一段文字这是一段
                      文字这是一段文字这是一段文字这是一段文字。
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco2.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span><a href="##">归属地变更</a></h1>
                    <p>
                      <span>变更内容：</span>这是一段文字这是一段文字这是一段文字。
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco3.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span><a href="##">归属地变更</a></h1>
                    <p>
                      <span>变更内容：</span>这是一段文字这是一段文字这是一段文字。
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco4.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span><a href="##">归属地变更</a></h1>
                    <p>
                      <span>变更内容：</span>这是一段文字这是一段文字这是一段文字。
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </el-tab-pane>

          <el-tab-pane label="浏览记录" name="second" :key="'second'">
            <div class="bzt">
              <ul>
                <p class="lineLeft"></p>
                <li>
                  <dd><img src="../../assets/img/show/tcIco1.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span></h1>
                    <p>
                      <span>浏览人账户：</span>浏览人账户浏览人账户
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco2.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span></h1>
                    <p>
                      <span>浏览人账户：</span>浏览人账户浏览人账户
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco3.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span></h1>
                    <p>
                      <span>浏览人账户：</span>浏览人账户浏览人账户
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco4.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span></h1>
                    <p>
                      <span>浏览人账户：</span>浏览人账户浏览人账户
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="申请记录" name="second2" :key="'second2'">
            <div class="bzt">
              <ul>
                <p class="lineLeft"></p>
                <li>
                  <dd><img src="../../assets/img/show/tcIco1.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span></h1>
                    <p>
                      <span>申请人账户：</span>申请人账户申请人账户
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco2.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span></h1>
                    <p>
                      <span>申请人账户：</span>申请人账户申请人账户
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco3.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span></h1>
                    <p>
                      <span>申请人账户：</span>申请人账户申请人账户
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco4.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span></h1>
                    <p>
                      <span>申请人账户：</span>申请人账户申请人账户
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="其他" name="second3" :key="'second3'">
            <div class="bzt">
              <ul>
                <p class="lineLeft"></p>
                <li>
                  <dd><img src="../../assets/img/show/tcIco1.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span><a href="##">归属地变更</a></h1>
                    <p>
                      <span>变更内容：</span>这是一段文字这是一段文字这是一段文字这是一段
                      文字这是一段文字这是一段文字这是一段文字这是一段文字这
                      是一段文字这是一段文字这是一段文字这是一段文字这是一段
                      文字这是一段文字这是一段文字这是一段文字。
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco2.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span><a href="##">归属地变更</a></h1>
                    <p>
                      <span>变更内容：</span>这是一段文字这是一段文字这是一段文字。
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco3.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span><a href="##">归属地变更</a></h1>
                    <p>
                      <span>变更内容：</span>这是一段文字这是一段文字这是一段文字。
                    </p>
                  </div>
                </li>
                <li>
                  <dd><img src="../../assets/img/show/tcIco4.png" alt=""></dd>
                  <div>
                    <img src="../../assets/img/show/sj.png" alt="">
                    <h1><span>2021-04-01   15：44</span><a href="##">归属地变更</a></h1>
                    <p>
                      <span>变更内容：</span>这是一段文字这是一段文字这是一段文字。
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>

      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: "zzpList",
  data() {
    return {
      input: '',
      //默认第一个选项卡
      activeName: "first",
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: true,
      formLabelWidth: '125px',
      tableData: [{
        date: 'RRICCATASOXJWD00764',
        name: '',
        address: '',
        sjdw: '中国热带农业科学院橡胶研究所',
        sjsj: '',

      }],
      tableData2: [{
        kbh: '',
        address: '',
        address2: '',
        bcdw: '中国热带农业科学院橡胶研究所',
        pbh: '',

      }]
    }
  },
  methods: {
    handleClick() {
    },
    open() {

    }
  },
};
</script>
<style scoped>
@import "../../assets/scss/show.css";

.bodyWrap {
  width: 100%;
  margin: 0 auto;
  background: #eeeeee;
}

.tabZujian {
  width: 1200px;
  margin: 0 auto;
}

.lineLeft {
  position: absolute;
  left: 22px;
  top: 25px;
  width: 2px;
  height: 480px;
  background: #02874a;
}

.bzt ul li {
  /* background: url(../../assets/img/show/tcIco1.png) no-repeat left center; */
  padding-left: 75px;
  vertical-align: top;
  position: relative;
  margin-bottom: 28px;
}

.bzt ul li dd {
  width: 16px;
  display: block;
  position: absolute;
  top: 12px;
  left: 0;
}

.bzt ul {
  position: relative;
}

.bzt ul li div {
  background: #fff;
  border-radius: 5px;
  padding: 20px;
  width: 395px;
  position: relative;
}

.bzt ul li div img {
  width: 16px;
  display: block;
  position: absolute;
  top: 25px;
  left: -16px;
}

.bzt ul li div h1 {
  font-size: 14px;
  font-weight: normal;
}

.bzt ul li div h1 span {
  color: #333333;
  border-radius: 30px;
  background: #eeeeee;
  width: 162px;
  height: 32px;
  display: inline-block;
  text-align: center;
  line-height: 33px;
}

.bzt ul li div h1 a {
  color: #02874a;
  float: right;
  display: inline-block;
  line-height: 33px;
  font-weight: bold;

}

.bzt ul li div p span {
  color: #333333;
  font-weight: bold;
  font-size: 14px;
}

.bzt ul li div p {
  color: #888888;
  font-size: 14px;
  margin-top: 15px;
  line-height: 22px;
}

.bzt {
  background: #eeeeee;
  padding: 20px 30px;
  position: relative;
  overflow-y: scroll;
  height: 550px;
}

.leftBox2 .el-table, .leftBox3 .el-table {
  margin-top: 18px;
}

.leftBox1 {
  border-bottom: 8px solid #eeeeee;
  padding: 18px 10px;
}

.wid100 {
  width: 100% !important;
}

.leftBox3 {
  padding: 0 10px 30px 10px;
}

.leftBox2 {
  border-bottom: 8px solid #eeeeee;
  padding: 0 10px 30px 10px;
}

.infoBox ul li {
  margin-top: 18px;
}

.infoBox ul li p {
  font-size: 14px;
  color: #333333;
  display: inline-block;
  width: 270px;
  font-weight: bold;
}

.infoBox ul li p span {
  font-size: 14px;
  color: #666666;
  font-weight: normal;
}

.leftBox1 h1 {
  font-size: 18px;
  color: #333333;
}

.titleSet {
  margin-top: 18px;
  font-size: 15px;
  background: url("../../assets/img/show/green.png") no-repeat left center;
  padding-left: 18px;
  color: #02874a;
  background-size: 11px 14px;
}

.leftBox1 h1 img {
  float: right;
  vertical-align: top;
  margin-top: -10px;
}

.leftBox2 {
  border-bottom: 8px solid #eeeeee;
}

.resourceCon {
  width: 1200px;
  margin: 0 auto;
}

.conLeft {
  width: 905px;
  background: #fff;
  display: inline-block;
  height: 690px;
}

.conRig {
  width: 287px;
  background: #fff;
  height: 690px;
}

.rigBox2 {
  width: 258px;
  display: inline-block;
  background: #fff;
  padding: 20px 10px 15px 10px;
}

.rigBox1 img {
  width: 225px;
  height: 51px;
  display: block;
  margin-top: 10px;
}

.rigBox1 h2 {
  font-size: 18px;
  color: #333333;
  margin-bottom: 7px;
}

.rigBox2 h2 {
  font-size: 18px;
  color: #333333;
  padding-left: 10px;
  margin-bottom: 7px;
}

.rigBox2 ul li {
  font-size: 15px;
  color: #666666;
  padding: 0 10px;
  border-bottom: 1px dashed #dfdfdf;
  height: 35px;
  line-height: 35px;
}

.rigBox2 ul li:last-child {
  border-bottom: 0;
}

.title {
  padding: 17px 0;
}

.title p {
  font-size: 12px;
  color: #666666;
}

footer {
  height: 84px;
  line-height: 84px;
  background: #4a4e53;
  margin-top: 50px;
  text-align: center;
}

footer p {
  font-size: 14px;
  color: #fff;
}

.el-tabs__item {
  font-size: 20px;
  color: #02874a;
}

.bottomBox {
  width: 1200px;
  margin: 0 auto;
}

.headBottom {
  background: #fff;
  height: 100px;

}

.headSearch {
  height: 40px;
  margin-top: 30px;
  position: relative;
}

.rigBox1 {
  padding: 20px;
  border-bottom: 8px solid #eeeeee;
}

.headSearch span {
  background: #02874a;
  position: absolute;
  right: -45px;
  top: 0;
  height: 38px;
  width: 51px;
  border: 1px solid #02874a;
  border-top-right-radius: 5px;
  border-left: 0;
  border-bottom-right-radius: 5px;
}

.headSearch span img {
  margin: 0 auto;
  text-align: center;
  display: block;
  margin-top: 7px;
  height: 24px;
}

.botLeft img {
  width: 489px;
  height: 42px;
  display: block;
  margin-top: 29px;
}

.headUl li {
  font-size: 16px;
  color: #333333;
  display: inline-block;
  float: left;
  margin-right: 40px;
  line-height: 100px;
}

.topBox {
  width: 1200px;
  margin: 0 auto;
}

.headTop {
  background: #f1f1f1;
  height: 30px;
  line-height: 28px;
}

.el-input__inner {
  border: 1px solid #02874a !important;
  font-size: 14px;
}

.headLeft span {
  font-size: 12px;
  color: #666666;
  display: inline-block;
  margin-right: 30px;
}

.headRig span {
  font-size: 12px;
  color: #666666;
  margin-left: 30px;
  display: inline-block;
}
</style>
